var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisibilityOffPassword(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 8,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.284.662a.75.75 0 011.054.122l.174.22c2.23 2.767 5.114 4.11 7.957 4.11 2.844 0 5.729-1.344 7.96-4.113a.75.75 0 111.168.941 13.77 13.77 0 01-2.199 2.187l.625.865a.75.75 0 11-1.216.878l-.641-.887c-.808.49-1.65.87-2.514 1.14l.225.787a.75.75 0 11-1.442.413l-.244-.852a10.584 10.584 0 01-3.486-.008l-.244.858a.75.75 0 01-1.443-.409l.228-.801A11.402 11.402 0 013.732 4.96l-.627.86a.75.75 0 01-1.212-.883l.61-.837A13.79 13.79 0 01.342 1.942l-.004-.004-.176-.222A.75.75 0 01.284.662z",
    fill: "#C4C4C4"
  })));
}
export default SvgVisibilityOffPassword;